import { StyleSheet, Text, View } from "react-native";
import React from "react";
import Layout from "~components/atoms/Layout/index.web";

const CreateCompany = () => {
  return (
    <Layout>
      <Text>CreateCompany</Text>
    </Layout>
  );
};

export default CreateCompany;

const styles = StyleSheet.create({});
